"use client";

import { c as _c } from "react/compiler-runtime";
import { UserFollowBtnSize } from "@/components/user/utils/UserFollowBtn";
import type { DropInteractionParams } from "@/components/waves/drops/Drop";
import type { ExtendedDrop } from "@/helpers/waves/drop.helpers";
import type { ActiveDropState } from "@/types/dropInteractionTypes";
import type { INotificationPriorityAlert } from "@/types/feed.types";
import NotificationsFollowBtn from "../NotificationsFollowBtn";
import NotificationDrop from "../subcomponents/NotificationDrop";
import NotificationHeader from "../subcomponents/NotificationHeader";
import NotificationTimestamp from "../subcomponents/NotificationTimestamp";
import { getIsDirectMessage, useWaveNavigation } from "../utils/navigationUtils";
export default function NotificationPriorityAlert(t0) {
  const $ = _c(41);
  const {
    notification,
    activeDrop,
    onReply,
    onDropContentClick
  } = t0;
  const {
    createReplyClickHandler,
    createQuoteClickHandler
  } = useWaveNavigation();
  let t1;
  if ($[0] !== notification.related_identity) {
    t1 = <NotificationsFollowBtn profile={notification.related_identity} size={UserFollowBtnSize.SMALL} />;
    $[0] = notification.related_identity;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <span className="tw-text-iron-400">sent a priority alert 🚨</span>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== notification.created_at) {
    t3 = <span className="tw-text-sm tw-font-normal tw-text-iron-50">{t2}{" "}<NotificationTimestamp createdAt={notification.created_at} /></span>;
    $[3] = notification.created_at;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== notification.related_identity || $[6] !== t1 || $[7] !== t3) {
    t4 = <NotificationHeader author={notification.related_identity} actions={t1}>{t3}</NotificationHeader>;
    $[5] = notification.related_identity;
    $[6] = t1;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  const headerSection = t4;
  if (!notification.related_drops || notification.related_drops.length === 0) {
    let t5;
    if ($[9] !== headerSection) {
      t5 = <div className="tw-flex tw-w-full tw-gap-x-3"><div className="tw-flex tw-w-full tw-flex-col tw-space-y-2">{headerSection}</div></div>;
      $[9] = headerSection;
      $[10] = t5;
    } else {
      t5 = $[10];
    }
    return t5;
  }
  const drop = notification.related_drops[0];
  if (!drop) {
    return null;
  }
  let T0;
  let t10;
  let t11;
  let t12;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[11] !== activeDrop || $[12] !== createQuoteClickHandler || $[13] !== createReplyClickHandler || $[14] !== drop || $[15] !== headerSection || $[16] !== onReply) {
    const isDirectMessage = getIsDirectMessage(drop.wave);
    t12 = "tw-flex tw-w-full tw-gap-x-3";
    t10 = "tw-flex tw-w-full tw-flex-col tw-space-y-2";
    t11 = headerSection;
    T0 = NotificationDrop;
    t5 = drop;
    t6 = activeDrop;
    t7 = onReply;
    t8 = createReplyClickHandler(drop.wave.id, isDirectMessage);
    t9 = createQuoteClickHandler(isDirectMessage);
    $[11] = activeDrop;
    $[12] = createQuoteClickHandler;
    $[13] = createReplyClickHandler;
    $[14] = drop;
    $[15] = headerSection;
    $[16] = onReply;
    $[17] = T0;
    $[18] = t10;
    $[19] = t11;
    $[20] = t12;
    $[21] = t5;
    $[22] = t6;
    $[23] = t7;
    $[24] = t8;
    $[25] = t9;
  } else {
    T0 = $[17];
    t10 = $[18];
    t11 = $[19];
    t12 = $[20];
    t5 = $[21];
    t6 = $[22];
    t7 = $[23];
    t8 = $[24];
    t9 = $[25];
  }
  let t13;
  if ($[26] !== T0 || $[27] !== onDropContentClick || $[28] !== t5 || $[29] !== t6 || $[30] !== t7 || $[31] !== t8 || $[32] !== t9) {
    t13 = <T0 drop={t5} activeDrop={t6} onReply={t7} onReplyClick={t8} onQuoteClick={t9} onDropContentClick={onDropContentClick} />;
    $[26] = T0;
    $[27] = onDropContentClick;
    $[28] = t5;
    $[29] = t6;
    $[30] = t7;
    $[31] = t8;
    $[32] = t9;
    $[33] = t13;
  } else {
    t13 = $[33];
  }
  let t14;
  if ($[34] !== t10 || $[35] !== t11 || $[36] !== t13) {
    t14 = <div className={t10}>{t11}{t13}</div>;
    $[34] = t10;
    $[35] = t11;
    $[36] = t13;
    $[37] = t14;
  } else {
    t14 = $[37];
  }
  let t15;
  if ($[38] !== t12 || $[39] !== t14) {
    t15 = <div className={t12}>{t14}</div>;
    $[38] = t12;
    $[39] = t14;
    $[40] = t15;
  } else {
    t15 = $[40];
  }
  return t15;
}